module.exports = __webpack_public_path__ + "img/back.8e052600.png";